import { render, staticRenderFns } from "./ExportRecordTable.vue?vue&type=template&id=3e9f3467&"
import script from "./ExportRecordTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExportRecordTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports